import { Globe, Check } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const NATIVE = {
  en: "English", fr: "Français", de: "Deutsch", nl: "Nederlands", sv: "Svenska",
  pl: "Polski", fi: "Suomi", es: "Español", it: "Italiano", pt: "Português",
  ru: "Русский", ar: "العربية",
};

export const LanguageSwitcher = ({ triggerClassName = "text-foreground hover:bg-secondary" }) => {
  const { lang, setLang, languages } = useI18n();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={`gap-1.5 px-2 ${triggerClassName}`}
          data-testid="language-switcher-button"
          aria-label="Change language"
        >
          <Globe className="h-4 w-4" />
          <span className="text-xs font-semibold uppercase">{lang}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[180px]" data-testid="language-menu">
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLang(l.code)}
            data-testid={`language-option-${l.code}`}
            className="flex items-center justify-between gap-3"
          >
            <span className="flex items-center gap-2">
              <span className="text-xs font-semibold uppercase text-muted-foreground">{l.code}</span>
              {NATIVE[l.code] || l.name}
            </span>
            {lang === l.code && <Check className="h-4 w-4 text-boomerang" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
